const toast = "TOAST";
const user = "USER";

export { toast, user };
